import styled from "styled-components";

import { theme } from "../../styles/theme";

export const HeaderElement = styled.div`
  grid-area: header;
  width: 100%;
  height: 12vh;
  background-color: ${theme.colors.blue900};
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 0px 0px 16px 16px;

  @media screen and (max-width: 885px) {
    width: 100%;
  }

  @media screen and (max-width: 479px) {
    height: 10vh;
    max-width: 100vw;
  }
`;

export const HeaderMainElement = styled.div`
  display: flex;
  justify-content: center;
  background-color: #f4f2ff;
`;
